// extracted by mini-css-extract-plugin
module.exports = {"container":"Histgram_container__AGE9b","graph":"Histgram_graph__1IaKe"};